import { DetailsFL, FLTableData, ImpactChartData, ComponentDetails, CogsReference } from "../../interfaces";
import { ProductPriceVolumeResponse, PvElasticityResponse } from '../fl-pv-curve/fl-pv-curve.model';

export const FinishedLubesFeatureId = 'FinishedLubes';

export interface PvCurveEntry {
    priceVolume: ProductPriceVolumeResponse[];
    elasticity: PvElasticityResponse[];
    isLoading: boolean;
    error: string | null;
}

export interface FinishedLubesState {
    bestMatch: string;
    allForecastItems: DetailsFL[];
    filteredImpactItems: DetailsFL[];
    filteredDetailItems: DetailsFL[];
    impactChartData: ImpactChartData[];
    productTableRows: FLTableData[];
    outputDriverData: ComponentDetails[];
    selectedMbu: string;
    mbuListBase: string[];
    pbiListBase: string[];
    mbuList: string[];
    pbiList: string[];
    selectedPBI: string;
    isLoading: boolean;
    error: string | null;
    historicalFeedback: HistoricalFeedback;
    pvCurveCache: Record<string, PvCurveEntry>;
    selectedPvCurveKey: string | null;
}

export const initialFinishedLubesState: FinishedLubesState = {
    allForecastItems: [],
    filteredImpactItems: [],
    filteredDetailItems: [],
    impactChartData: [],
    bestMatch: '',
    selectedMbu: '',
    mbuListBase: ['All'],
    pbiListBase: ['All'],
    mbuList: [],
    pbiList: ['All'],
    productTableRows: [],
    outputDriverData: [],
    selectedPBI: 'All',
    isLoading: true,
    error: null,
    historicalFeedback: {
        history: [],
        prodLvl6: '',
        isLoading: false
    },
    pvCurveCache: {},
    selectedPvCurveKey: null,
}

export interface HistoricalFeedback {
    history: FinishedLubesHistoryFeedback[],
    prodLvl6: string;
    isLoading: boolean;
}

export interface FinishedLubesFeedback {
    productLevel6: string;
    productLine: string;
    productFamily: string;
    productGroup: string;
    marketSegment: string;
    acceptedPriceRecommendation: string;
    qualityConfirmationDescription: string;
    isCogsActive: boolean;
    isForexActive: boolean;
    marketRegime: number;
    cogs: number;
    cogsReference: CogsReference;
    forex: number;
    isMarketRegimeActive: boolean;
    acceptedPrice: number;
    priceImpactPct: number;
    priceImpactUsd: number;
    isSummaryLevelAccepted: boolean;
    modelRunDate: Date;
    pbi: string;
    mbu: string;
    createdDate?: Date;
    UserDisplayName?: string;
}

export interface FinishedLubesHistoryFeedback {
    productLevel6: string;
    productLine: string;
    productFamily: string;
    productGroup: string;
    marketSegment: string;
    acceptedPriceRecommendation: string;
    qualityConfirmationDescription: string;
    isCogsActive: boolean;
    isForexActive: boolean;
    isMarketRegimeActive: boolean;
    userEmail: string;
    acceptedPrice: number;
    priceImpactPct: number;
    modelRunDate: Date;
    pbi: string;
    createdDate: Date;
    userDisplayName?: string;
    submittedPricesCount?: number;
    previousModelRunDate?: Date
}


export interface FeedbackOutput {
    productLevel6: string;
    productLine: string;
    productFamily: string;
    productGroup: string;
    marketSegment: string;
    acceptedPriceRecommendation: string;
    qualityConfirmationDescription: string;
    isCogsActive: boolean;
    isForexActive: boolean;
    marketRegime: number;
    cogs: number;
    forex: number;
    isMarketRegimeActive: boolean;
    acceptedPrice: number;
    priceImpactPct: number;
    priceImpactUsd: number;
    isSummaryLevelAccepted: boolean;
    modelRunDate: Date;
    pbi: string;
    mbu: string;
    createdDate: Date;
}
